<template>
  <div class="not-found">
    <div class="content">
      <b-img-lazy
        v-if="!notFoundPage"
        class="image"
        :src="cx_image"
        alt="página não encontrada marketplace Clinicarx"
        title="página não encontrada  marketplace Clinicarx"
      ></b-img-lazy>
      <b-img-lazy
        v-if="notFoundPage"
        class="image"
        :src="cx_image_NotFound"
        alt="página não encontrada marketplace Clinicarx"
        title="página não encontrada  marketplace Clinicarx"
      ></b-img-lazy>      
      <div v-if="notFoundPage" class="col-12 col-md-6">
        <p class="text-center font-weight-bold home-service-title main-text">
          Ops! Página não encontrada
        </p>
        <p class="message-notFound">
          Parece que você tentou acessar uma página inexistente. Você pode usar a busca no topo dessa
          página ou voltar e tentar novamente.
        </p>
        <b-button @click="goToHomePage()" class="btn-home">Voltar a página inicial</b-button>
      </div>
      <div v-if="noNearbyClinics">
        <p class="home-service-title main-text">
          Infelizmente não encontramos nenhum ponto de saúde parceiro da Clinicarx nessa região.
        </p>
        <p class="error-info">
          Você pode alterar o endereço de busca ou voltar para a tela do serviço e buscar por um serviço relacionado.
        </p>
        <b-button @click="goToServicePage()" class="btn-home">Voltar a página do serviço</b-button>
      </div>
      <div v-else-if="noAddress || locationBlocked">
        <p v-if="noAddress" class="home-service-title main-text">
          Precisamos de uma localização para realizar a busca.
        </p>
        <p v-else class="home-service-title main-text">
          Localização bloqueada no seu navegador.
        </p>
        <p class="error-info">
          Habilite a sua localização para pesquisar pontos de saúde próximos a você ou insira um CEP válido no topo da página e clique em buscar.
        </p>
        <b-button v-if="noAddress" @click="allowLocation()" class="btn-home">Usar minha localização</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import NotFoundPage from "@/views/NotFound/NotFoundPage";
export default NotFoundPage;
</script>

<style lang="scss">
@import "NotFoundPage.scss";
</style>
